import { useState } from "react";
import TeambookTextForm from "../../default_components/TeambookTextForm";
import Api from "../../../Api";
import { useTranslation } from "react-i18next";
import TeambookDialog from "../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const TwoFactorModal = ({ open, setOpen, email, redirectToMainPage }) => {
  const [code, setCode] = useState(null);
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorField, setErrorField] = useState(null);

  const analyzeResponse = (response) => {
    if (response.status === 201) {
      const token = response.data.token;
      const language = response.data.lang;

      localStorage.setItem("Auth-Token", token);
      localStorage.setItem("tb-lang", language);

      Api.updateParamTokens(token);

      redirectToMainPage();
    } else {
      setErrorMessage("error");
    }
  };

  const submitForm = () => {
    Api.Auth.validate_two_factor(email, code)
      .then(analyzeResponse)
      .catch((error) => {
        setErrorMessage(error.response.data.error);
        setErrorField("code");
      });
  };

  const sendAgain = () => {
    Api.Auth.send_two_factor(email).then(() => {
      setCode("");
    });
  };

  const closeModal = () => {
    setOpen(false);
    setErrorField(null);
    setErrorMessage(null);
  };

  const closeErrorMessage = () => {
    setErrorMessage(null);
    setErrorField(null);
  };

  return (
    <TeambookDialog
      open={open}
      onClose={closeModal}
      title={"Two-Step Verification"}
      withCloseButton
      content={
        <>
          <p>
            {t("auth.two_factor_account_request")}
            <br/>
            {t("auth.two_factor_check")}
          </p>

          <TeambookTextForm
            width={"120px"}
            fieldName={"Code"}
            onChange={setCode}
            fieldValue={code}
            style={{marginTop: "15px"}}
            errorField={errorField}
            errorMessage={errorMessage}
            field={"code"}
            inputBottomOffset={"15px"}
            closeErrorMessage={closeErrorMessage}
          />

          <a
            onClick={sendAgain}
            href={"#"}
            style={{
              fontSize: 14,
              textDecoration: "underline",
            }}
          >
            {t("auth.send_again")}
          </a>
        </>
      }
      actionButtons={[
        {
          text: t("submit"),
          onClick: submitForm,
        },
      ]}
    />
  );
};

TwoFactorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  redirectToMainPage: PropTypes.func.isRequired,
};

export default TwoFactorModal;
